







































import { Watch, Component, Prop, Vue } from 'vue-property-decorator';
import { CmsDeserializer, TeaserTile } from '@/services/CmsDeserializer';
import { namespace } from 'vuex-class';
import { WINDOW_WIDTH } from '@/store/types';
import MobileUtil from '@/common/MobileUtil';
import MatomoContentInteraction from '@/matomo/MatomoContentInteraction';

const windowWidth = namespace(WINDOW_WIDTH);

@Component
export default class TeaserTiles extends Vue {
  @Prop({ required: true })
  public localTiles: string;
  public currentPageIndex: number = 0;

  @windowWidth.State('windowWidth')
  private windowWidth: number;

  public get pageSize(): number {
    if (MobileUtil.isMobile(this.windowWidth)) {
      return 1;
    }
    return 3;
  }

  public get tiles(): TeaserTile[] {
    return CmsDeserializer.parseTeaserTiles(this.localTiles);
  }

  public trackInteraction(event: Event) {
    MatomoContentInteraction.fromTarget(event.target).withClickAction().publishInteraction();
  }

  public isInCurrentPage(index: number): string {
    if (this.currentPageIndex <= index && index < this.currentPageIndex + this.pageSize) {
      return '';
    } else {
      return 'cms-tsrt-hidden';
    }
  }

  public get showPrevButton(): boolean {
    return this.currentPageIndex > 0;
  }

  public get showNextButton(): boolean {
    return this.currentPageIndex < this.tiles.length - this.pageSize;
  }

  public goToPreviousPage() {
    if (this.currentPageIndex <= 0) {
      return;
    }
    this.currentPageIndex -= 1;
  }

  public goToNextPage() {
    if (this.currentPageIndex >= this.tiles.length - this.pageSize) {
      return;
    }
    this.currentPageIndex += 1;
  }

  public computeBackgroundStyle(tile: TeaserTile): string {
    if (!tile.imageUrl) {
      return '';
    } else {
      return 'background-image: url("' + tile.imageUrl + '")';
    }
  }

  @Watch('windowWidth')
  private onResize(newValue: number, oldValue: number) {
    if ((MobileUtil.isMobile(newValue) && !MobileUtil.isMobile(oldValue))
      || (!MobileUtil.isMobile(newValue) && MobileUtil.isMobile(oldValue))) {
      this.currentPageIndex = 0;
    }
  }

}
